import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MarketService} from "../../services/market/market.service";
import {Subject} from "rxjs";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {takeUntil} from "rxjs/operators";
import {IMarketItems} from "../../services/market/market.interface";


@Component({
  selector: 'app-refill-items',
  templateUrl: './refill-items.component.html',
  styleUrls: ['./refill-items.component.scss']
})
export class RefillItemsComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;

  public kits: IMarketItems | null = null;
  public isLoading = true;

  // Лимит backend (admin-panel-api/market/market.controller.ts PAGINATION_PAGE_SIZE_MAX = 40)
  // — мы не можем выйти за него без правки бэка.
  public pageSize = 40;
  public currentPage = 0;
  public pageSizeOptions: number[] = [10, 20, 40];

  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private marketService: MarketService) {}

  ngOnInit(): void {
    this.marketService.marketItems$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((kits: IMarketItems) => {
        this.kits = kits;
        this.isLoading = false;
        if (this.paginator) {
          this.paginator.length = kits?.count ?? 0;
          this.paginator.pageIndex = this.currentPage;
        }
      });

    this.loadPage();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public pageChanged(event: PageEvent): void {
    this.isLoading = true;
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadPage();
  }

  private loadPage(): void {
    this.isLoading = true;
    this.marketService.requestMarketItems(this.pageSize, this.currentPage);
  }
}
